import styled from 'styled-components';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

const INPUT_HEIGHT = 48;
const INPUT_HORIZONTAL_PADDING = 18;
const LABEL_LINE_HEIGHT = 16;
const LABEL_MARGIN_BOTTOM = 7;
const FOCUS_SHADOW_BLUR = 4;

export const $PaymentAdyenContainer = styled.div`
  --adyen-sdk-color-label-primary: ${({ theme }) => theme.colors.mainTextColor};
  --adyen-sdk-color-label-secondary: ${({ theme }) =>
    theme.newUI.defaultColors.secondaryText};
  --adyen-sdk-color-label-critical: ${({ theme }) => theme.colors.danger};
  --adyen-sdk-color-outline-tertiary: ${({ theme }) => theme.colors.default};
  --adyen-sdk-color-outline-tertiary-hover: ${({ theme }) =>
    theme.colors.primary};
  --adyen-sdk-color-outline-tertiary-active: ${({ theme }) =>
    theme.colors.primary};
  --adyen-sdk-color-outline-primary-active: ${({ theme }) =>
    theme.colors.primary};
  --adyen-sdk-color-outline-critical: ${({ theme }) => theme.colors.danger};
  --adyen-sdk-color-background-disabled: ${({ theme }) =>
    theme.colors.disabled};
  --adyen-sdk-border-width-s: ${({ theme }) => theme.borders.thickness};
  --adyen-sdk-border-radius-m: ${({ theme }) => theme.borders.radius};
  --adyen-sdk-focus-ring-color: ${({ theme }) =>
    theme.newUI.variationColors.light3};

  & .adyen-checkout__label__text {
    font-size: ${({ theme }) => theme.fonts.size.small};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: ${rem(LABEL_LINE_HEIGHT)};
    margin-bottom: ${rem(LABEL_MARGIN_BOTTOM)};
  }

  & .adyen-checkout__label__text:not(.adyen-checkout__label__text--error),
  &
    .adyen-checkout__label--focused
    .adyen-checkout__label__text:not(.adyen-checkout__label__text--error) {
    color: ${({ theme }) => theme.newUI.defaultColors.secondaryText};
  }

  & .adyen-checkout__input {
    height: ${rem(INPUT_HEIGHT)};
    padding: 0 ${rem(INPUT_HORIZONTAL_PADDING)};
    font-size: ${({ theme }) => theme.fonts.size.small};
  }

  & .adyen-checkout__input-wrapper:focus-within,
  & .adyen-checkout__input-wrapper:focus-within:hover,
  & .adyen-checkout__label--focused + .adyen-checkout__input-wrapper {
    box-shadow: 0 0 ${rem(FOCUS_SHADOW_BLUR)}
      ${({ theme }) => theme.newUI.variationColors.light3};
  }

  & .adyen-checkout__button--pay:not(.adyen-checkout__button--loading) {
    background: ${({ theme }) => theme.colors.primary};
  }

  & .adyen-checkout__payment-method--selected {
    background: transparent;
  }
  & .adyen-checkout__image {
    width: 50px;
  }

  & .adyen-checkout__label__text::after {
    content: ' *';
    color: ${({ theme }) => theme.colors.danger};
  }
`;
